
import {defineComponent} from 'vue'
import {ElMessageBox} from "element-plus";
import {Delete, Edit, Plus} from '@element-plus/icons-vue'
import compressApi from "@/api/compress";
import tablePager from "@/components/table-pager.vue";
import i18n from '@/i18n';

const {t} = i18n.global;
export default defineComponent({
  name: 'compress-setting',
  setup() {
    return {
      Plus, Edit, Delete
    }
  },
  // 数据
  data() {
    return {
      count: 0,
      addDialog: false,
      dialogFormVisible: false,
      tableData: [],
      formLabelWidth: '120px'
    }
  },

  // 传值
  props: [],

  // 计算
  computed: {},

  // 组件
  components: {tablePager},

  // 方法
  methods: {
    /**
     * 删除书签
     * @param index
     * @param val
     * @returns {Promise<void>}
     */
    async handleDelete(index: number, val: any) {

      ElMessageBox.confirm(
          t('compressManage.confirm.text'),
          t('compressManage.confirm.title'), {
            type: 'warning'
          }).then(async () => {
        const res = await compressApi.delete_compress(val.compressId);

        if (res.code === 0) {
          this.reload_table();
        }
      }).catch(() => {
      })
    },

    /**
     * 加载表格
     * @returns {Promise<void>}
     */
    async load_table(page = 1, pageSize = 10) {
      const res = await compressApi.get_compress(page, pageSize);
      this.count = Number(res.count);
      this.tableData = res.list;
    },
    /**
     * 重载数据 页码不变
     */
    reload_table() {
      (this.$refs as any).pager.reload_page();
    },
  },

  // 生命周期
  created() {
    this.load_table();
  },
})
